import {
  Switch as ChakraSwitch,
  SwitchProps as ChakraSwitchProps,
  FormLabel,
  FormControl,
  FormErrorMessage,
  HStack,
} from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';

import { FieldError } from 'react-hook-form';

interface ISwitchProps extends ChakraSwitchProps {
  name: string;
  label?: string;
  error?: FieldError;
  inline?: boolean;
}

const SwitchBase: ForwardRefRenderFunction<HTMLInputElement, ISwitchProps> = (
  { name, label, error = null, inline = false, isDisabled, ...rest },
  ref,
) => (
  <FormControl isInvalid={!!error} isDisabled={isDisabled}>
    {inline ? (
      <HStack alignItems="center">
        <ChakraSwitch ref={ref} name={name} id={name} {...rest} />

        {!!label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      </HStack>
    ) : (
      <>
        {!!label && <FormLabel htmlFor={name}>{label}</FormLabel>}

        <ChakraSwitch
          ref={ref}
          name={name}
          id={name}
          isDisabled={isDisabled}
          {...rest}
        />
      </>
    )}

    {!!error && (
      <FormErrorMessage position="absolute">{error.message}</FormErrorMessage>
    )}
  </FormControl>
);

export const Switch = forwardRef(SwitchBase);
